import { Check, Brain, Ribbon } from "lucide-react";

const mri = [
  "RM Addome superiore e inferiore",
  "RM Pelvi femminile",
  "RM Multiparametrica della prostata",
  "RM Lombosacrale",
  "RM Articolare (spalla, ginocchio, anca, caviglia, polso)",
];

const senology = [
  "Mammografia con tomosintesi",
  "Mammografia con mezzo di contrasto (CESM)",
  "Ecografia mammaria",
  "Ecografia addominale",
  "Ecografia collo e tiroide",
  "Ecografia muscolo-scheletrica e articolare",
  "Ecografia cute, tessuto sottocutaneo e linfonodi",
  "Screening neonatale della displasia congenita dell'anca",
];

export default function Services() {
  return (
    <section
      id="competenze"
      data-testid="services-section"
      className="py-24 lg:py-32 border-t border-stone-200 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="eyebrow">Aree di competenza</span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1]">
              Due aree di specializzazione, una cura unica.
            </h2>
          </div>
          <p className="text-stone-600 max-w-md leading-relaxed">
            Ho scelto di concentrare la mia attività libero-professionale su Risonanza Magnetica body
            e diagnostica senologica, le aree in cui ho costruito esperienza più solida. RM e mammografia sono eseguibili presso la Casa di Cura Palazzolo; le prestazioni ecografiche anche presso Life Clinic e lo studio del Dr. Berbenni.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          <Pillar
            testid="service-pillar-mri"
            eyebrow="01 — Risonanza Magnetica"
            icon={<Brain size={20} />}
            title="RM Body & Muscolo-scheletrica"
            image="https://customer-assets.emergentagent.com/job_radiolog-clinic/artifacts/p0bjxf88_1000144667.jpg"
            imageAlt="Risonanza Magnetica Siemens MAGNETOM Sola 1,5 T — Casa di Cura Palazzolo"
            items={mri}
          />
          <Pillar
            testid="service-pillar-senology"
            eyebrow="02 — Senologia & Ecografia"
            icon={<Ribbon size={20} />}
            title="Diagnostica senologica & ecografica"
            image="https://customer-assets.emergentagent.com/job_radiolog-clinic/artifacts/ipir17ol_1000144664.jpg"
            imageAlt="Mammografo Siemens MAMMOMAT B.brilliant — Casa di Cura Palazzolo"
            items={senology}
          />
        </div>
      </div>
    </section>
  );
}

function Pillar({ testid, eyebrow, icon, title, image, imageAlt, items }) {
  return (
    <article
      data-testid={testid}
      className="rounded-3xl border border-stone-200 bg-white overflow-hidden hover:shadow-md transition-shadow duration-300"
    >
      <div className="relative aspect-[16/9] overflow-hidden bg-stone-100">
        <img src={image} alt={imageAlt || title} className="w-full h-full object-cover" />
      </div>
      <div className="p-8 lg:p-10">
        <div className="flex items-center gap-3 mb-2">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#E9F0EE] text-[#3E615B]">
            {icon}
          </span>
          <span className="text-[11px] uppercase tracking-[0.22em] text-stone-500">
            {eyebrow}
          </span>
        </div>
        <h3 className="mt-2 font-display text-2xl md:text-3xl font-medium text-stone-900 tracking-tight">
          {title}
        </h3>

        <ul className="mt-6 space-y-3">
          {items.map((it) => (
            <li
              key={it}
              className="flex items-start gap-3 text-stone-700 leading-snug"
            >
              <span className="mt-1 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#3E615B]/10 text-[#3E615B]">
                <Check size={12} strokeWidth={3} />
              </span>
              <span className="text-[15px]">{it}</span>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}
